import styled, { css } from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

type StyledProps = {
  type: string;
};

export const Image = styled.img`
  height: 49px;
  object-fit: contain;
`;

export const DesktopStyle = css`
  display: flex;
  a {
    font-size: 13px;
    text-transform: uppercase;
    font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
    font-weight: 900;
    margin-right: 10px;
    align-self: center;
  }
  @media (max-width: ${defaultBreakpoints.medium}) {
    display: none;
  }
`;

export const MobileStyle = css`
  display: none;
  @media (max-width: ${defaultBreakpoints.medium}) {
    display: flex;
    flex-direction: column;
    border-top: ${({ theme }) => `1px solid ${theme.default.color.text.light}`};

    a {
      font-size: 13px;
      text-transform: uppercase;
      font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
      font-weight: 900;
      margin-right: 10px;
      text-align: left;
      margin: 8px 0;
    }
    img {
      margin-bottom: 10px;
      margin-right: auto;
      justify-self: flex-start;
    }
  }
`;

export const Wrapper = styled.div<StyledProps>`
  ${({ type }) => type === "desktop" && DesktopStyle}
  ${({ type }) => type === "mobile" && MobileStyle}
`;
